const Features = {
  hubspotSync: process.env.HubspotSync === 'true',
  useDemoIndexPageTitle: process.env.Env === 'demo',
  footerComponent: process.env.FooterComponent === 'true',
  useDemoAnalytics: process.env.Env === 'demo',
  accountSetUpRequired: process.env.Env !== 'demo',
  integrationsManagement: process.env.IntegrationsManagement === 'true',
  isUnderMaintenance: process.env.isUnderMaintenance === 'true',
  paidVersionLaunch: process.env.PaidVersionLaunch === 'true',
  showCampaignObjectiveSelectionPage:
    process.env.ShowCampaignObjectiveSelectionPage === 'true',
  shopifyIntegrationForMobizClient:
    process.env.ShopifyIntegrationForMobizClient === 'true'
};

export default Features;
